/**
 * `settings:` (PLAN §2.2, S4): the Settings tabs and the row-level words people
 * type ("proxy", "2FA", "invoices"), the same index as the Settings sidebar
 * filter (settingsTabs.js). Enter opens Settings on that tab.
 */
import { Settings } from 'lucide-react';
import { ORDER } from './order';
import { selectTop } from '../localSearch';
import { openAction } from '../actions';
import { TABS, SETTINGS_SEARCH_KEYWORDS, TAB_SUBTITLE } from '../../components/settings/settingsTabs';
import i18n from '../../i18n';

let cache = { key: null, rows: [] };

/** The rows, rebuilt only when the language or the sign-in state changes (one array per key). */
export function settingsResults(ctx) {
  const key = `${i18n.language}|${ctx.currentUserId ? 1 : 0}`;
  if (cache.key === key && cache.t === ctx.t) return cache.rows;
  const rows = buildSettingsResults(ctx);
  cache = { key, t: ctx.t, rows };
  return rows;
}

function buildSettingsResults(ctx) {
  return TABS.filter((tab) => !tab.authOnly || ctx.currentUserId).map((tab) => ({
    provider: 'settings',
    id: tab.id,
    title: ctx.t(tab.labelKey),
    subtitle: TAB_SUBTITLE[tab.id] ? ctx.t(TAB_SUBTITLE[tab.id]) : undefined,
    icon: tab.Icon || Settings,
    searchFields: (SETTINGS_SEARCH_KEYWORDS[tab.id] || []).map((k) => ({ text: k, weight: 0.4 })),
    payload: { tabId: tab.id },
  }));
}

export default function create() {
  return {
    id: 'settings',
    prefixes: ['settings', 's', 'setting', 'prefs'],
    labelKey: 'palette.scope.settings',
    icon: Settings,
    order: ORDER.settings,
    kind: 'local-sync',
    available: () => true,
    search(req) {
      return selectTop(settingsResults(req.ctx), req);
    },
    async recent(ids, ctx) {
      const all = settingsResults(ctx);
      return ids.map((id) => all.find((r) => r.id === id)).filter(Boolean);
    },
    actions() {
      return [openAction((r, ctx) => ctx.nav.onOpenSettings?.(r.payload.tabId))];
    },
  };
}
